import { isWindowUndefined, parseQueryString } from '../utils/helper';
import { type PageViewAttributes } from './types';

export const logToConsole = (level: 'info' | 'error', ...args: any[]): void => {
  if (level === 'error') {
    console.error(...args);
  } else {
    console.log(...args);
  }
};

export function createPageViewAttributes(attributes: PageViewAttributes): PageViewAttributes {
  if (isWindowUndefined()) return attributes;

  const { title } = document;
  const { href, pathname, search } = window.location;
  return {
    page_title: title,
    page_path: pathname,
    page_url: href,
    query_params: parseQueryString(search),
    ...attributes,
  };
}

export function pushToDataLayer(payload: Record<string, any>): void {
  if (isWindowUndefined()) return;

  (window as any).dataLayer.push({
    _clear: true,
    ...payload,
  });
}

export function logEvent(payload: Record<string, any>): void {
  logToConsole(
    'info',
    `"${payload.event
    }" event has been received with below payload: `,
    payload,
  );
}
